export const SUP_PRESS_RELEASES_DETAILS_LOADER = {
  desktop: `
<div class="cui cui-grid">
  <div class="cui-container display-none display-lg-block">
        <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--desktop">
      <div class="cui-skeleton-heading__content" style="width: 60%">
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 48px"></div>
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 48px"></div>
        <div class="cui-skeleton__item -spacing--bottom-16" style="height: 48px"></div>
      </div>
    </div>
    <div class="cui-skeleton-paragraph -spacing--bottom-40 -spacing--top-40">
      <div class="cui-skeleton-paragraph__content" style="width: 100%">
        <div class="cui-skeleton__item" style="height: 16px"></div>
      </div>
    </div>
    <!--Description -->
    <div class="cui-row -spacing--bottom-40">
      <div class="cui-col-lg-8">
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
        </div>
      </div>
    </div>
    <!-- Blocks -->
    <div class="cui-row -spacing--bottom-40">
      <div class="cui-col-lg-8">
        <div class="cui-skeleton__item -spacing--bottom-16" style="width: 50%; height: 48px"></div>
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
        </div>
      </div>
    </div>
    <div class="cui-row -spacing--bottom-40">
      <div class="cui-col-lg-8">
        <div class="cui-skeleton__item -spacing--bottom-16" style="width: 50%; height: 48px"></div>
        <div class="cui-skeleton-paragraph__content" style="width: 100%">
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
          <div class="cui-skeleton__item" style="height: 18px"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
